// Colors of the charts come from the CSS variables of the site theme (public/css/variables.css), read at run time:
// no color value is written in the code. Browser only; on the server (or when a variable is missing) an empty string is
// returned and chart.js falls back to its own defaults.

export function resolveCssColor(variableName) {
  if (typeof document === 'undefined' || !document.body) return '';
  const probe = document.createElement('span');
  probe.style.display = 'none';
  probe.style.color = `var(${variableName})`;
  document.body.appendChild(probe);
  const color = window.getComputedStyle(probe).color || '';
  document.body.removeChild(probe);
  return color;
}

// Adds transparency to a computed color ('rgb(r, g, b)' or 'rgba(r, g, b, a)').
export function withAlpha(color, alpha) {
  const match = /^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i.exec(color || '');
  return match ? `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${alpha})` : color;
}

// Theme variables used by the reporting charts (see variables.css).
export const THEME_VARS = {
  line: '--primary-link-foreground',
  grid: '--primary-border',
  ticks: '--tertiary-foreground',
  tooltipBg: '--common-tooltip-bg',
  tooltipText: '--common-tooltip-foreground',
  pointFill: '--primary-white-bg',
  segmentBorder: '--primary-white-bg',
};

// Donut segments: variable of the theme per component (also used by the legend dots through CSS var()).
export const SEGMENT_VARS = {
  rental: '--primary-link-foreground',
  options: '--inbox-securityDepositBtn-color',
  delivery: '--inbox-inquiryBtn-color',
  other: '--tertiary-foreground',
};

export function readChartTheme() {
  const theme = {};
  Object.keys(THEME_VARS).forEach((key) => { theme[key] = resolveCssColor(THEME_VARS[key]); });
  return theme;
}
